import React, { useState, type FC } from 'react'
import { useIntl } from 'react-intl'
import { useAtom } from 'jotai'
import {
  FormElement,
  Text,
  GridCell,
  InputNumber,
  INPUT_TEXT_VARIANT_DANGER,
} from 'mailup-web-components'
import { filterFormImmerAtom } from '../../state/state'
import { type ConditionProps } from '../../types'
import styled from '@emotion/styled'
import { validateIntegerValue } from '../../utils/profileFieldSpecValidation'
import { type UiDateTimeSpec } from '../../filterConditionTypes'

const isValid = (spec: UiDateTimeSpec): boolean => {
  return validateIntegerValue(spec)
}

const StyledText = styled(Text)`
  padding-top: 8px;
`

const DateTimeSpecCondition: FC<ConditionProps> = ({
  blockIndex,
  condIndex,
}) => {
  const intl = useIntl()
  const [filter, setFilter] = useAtom(filterFormImmerAtom)
  const condition = filter.Blocks[blockIndex].Conditions[condIndex]
  const spec = condition.Spec as UiDateTimeSpec

  const [isValueDirty, setIsValueDirty] = useState(false)

  const handleValueChange = (value: number): void => {
    setIsValueDirty(true)
    setFilter((draft) => {
      const spec = draft.Blocks[blockIndex].Conditions[condIndex]
        .Spec as UiDateTimeSpec
      spec.Value = value
    })
  }

  const invalidValueMessage =
    spec.Value === undefined
      ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
      : intl.formatMessage({ id: 'Load.Filters.InvalidInteger' })
  const feedback =
    isValueDirty && !isValid(spec) ? invalidValueMessage : undefined

  return (
    <>
      <GridCell span={3}>
        <StyledText>
          {intl.formatMessage({
            id: 'Load.Filters.PassedExactlyFrom',
          })}
        </StyledText>
      </GridCell>
      <GridCell span={3}>
        {spec.Value !== undefined && (
          <FormElement
            data-mu-test='filterForm-UiDateTimeSpec-values_element'
            feedback={feedback}
          >
            <InputNumber
              data-mu-test='filterForm-UiDateTimeSpec-values_input'
              name='UiDateTimeSpec-values'
              value={spec.Value}
              onChange={handleValueChange}
              placeholder={intl.formatMessage({
                id: 'Load.Filters.InsertValuePlaceholder',
              })}
              variant={
                feedback !== undefined ? INPUT_TEXT_VARIANT_DANGER : undefined
              }
              maxLength={8}
              precision={0}
              step={1}
              pattern={'\\d+'}
            />
          </FormElement>
        )}
      </GridCell>
      <GridCell span={3}>
        <StyledText>
          {intl.formatMessage({
            id: 'Load.MailupCommon.Hours',
          })}
        </StyledText>
      </GridCell>
    </>
  )
}

export default DateTimeSpecCondition
